import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import ForcePasswordChange from "@/components/ForcePasswordChange";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Loans from "@/pages/Loans";
import LoanDetail from "@/pages/LoanDetail";
import LoanDocuments from "@/pages/LoanDocuments";
import DocumentVerification from "@/pages/DocumentVerification";
import Notifications from "@/pages/Notifications";
import Team from "@/pages/Team";
import CallLogs from "@/pages/CallLogs";
import Analytics from "@/pages/Analytics";
import Visits from "@/pages/Visits";
import Branches from "@/pages/Branches";
import Reports from "@/pages/Reports";
import CustomerPortal from "@/pages/CustomerPortal";
import EmployeeManagement from "@/pages/EmployeeManagement";
import AuditLog from "@/pages/AuditLog";

function AuthedApp({ children }) {
    return (
        <ProtectedRoute>
            <>
                <ForcePasswordChange />
                <Layout>{children}</Layout>
            </>
        </ProtectedRoute>
    );
}

function RootRedirect() {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (!user) return <Navigate to="/login" replace />;
    if (user.role === "customer") return <CustomerPortal />;
    return <Dashboard />;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/" element={<AuthedApp><RootRedirect /></AuthedApp>} />
                        <Route path="/loans" element={<AuthedApp><Loans /></AuthedApp>} />
                        <Route path="/loans/:id" element={<AuthedApp><LoanDetail /></AuthedApp>} />
                        <Route path="/loans/:id/documents" element={<AuthedApp><LoanDocuments /></AuthedApp>} />
                        <Route path="/customers" element={<AuthedApp><Customers /></AuthedApp>} />
                        <Route path="/documents" element={<AuthedApp><DocumentVerification /></AuthedApp>} />
                        <Route path="/notifications" element={<AuthedApp><Notifications /></AuthedApp>} />
                        <Route path="/team" element={<AuthedApp><Team /></AuthedApp>} />
                        <Route path="/calls" element={<AuthedApp><CallLogs /></AuthedApp>} />
                        <Route path="/analytics" element={<AuthedApp><Analytics /></AuthedApp>} />
                        <Route path="/visits" element={<AuthedApp><Visits /></AuthedApp>} />
                        <Route path="/branches" element={<AuthedApp><Branches /></AuthedApp>} />
                        <Route path="/reports" element={<AuthedApp><Reports /></AuthedApp>} />
                        <Route path="/employees" element={<AuthedApp><EmployeeManagement /></AuthedApp>} />
                        <Route path="/audit" element={<AuthedApp><AuditLog /></AuthedApp>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster position="top-right" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
